import { render, staticRenderFns } from "./CollegeListRecommend.vue?vue&type=template&id=54336400&scoped=true"
import script from "./CollegeListRecommend.vue?vue&type=script&lang=js"
export * from "./CollegeListRecommend.vue?vue&type=script&lang=js"
import style0 from "./CollegeListRecommend.vue?vue&type=style&index=0&id=54336400&prod&scoped=true&lang=less"
import style1 from "./CollegeListRecommend.vue?vue&type=style&index=1&id=54336400&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54336400",
  null
  
)

export default component.exports